export default __webpack_public_path__ + "90de406e311804570e68cccc545111b2.svg";